import classNames from "classnames";
import { Tag } from "antd/lib";
import { useTranslation } from "react-i18next";
import { AlertIcon, IdeasIcon, LifeStoryIcon, NoteIcon, UsersIcon } from "@/shared/icons";
import type { FC } from "react";
import type { NoteStatus, NoteTypes } from "@/services/api/entities/note/types";
import styles from "../../styles.module.scss";

type Props = {
  noteType: NoteTypes;
  status: NoteStatus;
};

export const NoteTypeTag: FC<Props> = ({ noteType, status, ...props }) => {
  const { t } = useTranslation();

  const getType = () => {
    switch (noteType) {
      case "DEFAULT_COMMITMENT":
        return {
          class: status === "DONE" ? "done" : "commitment",
          text: t("common.noteType.commitment", { count: 1 }),
          icon: (
            <AlertIcon
              width={12}
              height={12}
              className={classNames({
                [styles["tag-commitment"]]: status !== "DONE",
              })}
            />
          ),
        };
      case "DEFAULT_NOTE":
        return {
          class: "note",
          text: t("common.noteType.note", { count: 1 }),
          icon: <NoteIcon width={12} height={12} className={styles["tag-note"]} />,
        };
      case "DEFAULT_IDEA":
        return {
          class: "idea",
          text: t("common.noteType.idea", { count: 1 }),
          icon: <IdeasIcon width={12} height={12} className={styles["tag-idea"]} />,
        };
      case "DEFAULT_LIFE_STORY":
        return {
          class: "story",
          text: t("common.noteType.lifeStory", { count: 1 }),
          icon: <LifeStoryIcon width={9} height={12} className={styles["tag-life-story"]} />,
        };
      case "DEFAULT_MEETING":
        return {
          class: "meeting",
          text: t("common.noteType.meeting", { count: 1 }),
          icon: <UsersIcon width={13} height={13} className={styles["tag-meeting"]} />,
        };
      default:
        return {
          class: "note",
          text: t("common.noteType.note", { count: 1 }),
          icon: <NoteIcon width={12} height={12} className={styles["tag-note"]} />,
        };
    }
  };
  const tag = getType();
  return (
    <Tag className={classNames(styles["header-tag"], styles[`header-tag-${tag.class}`])} {...props}>
      <div className={styles["header-tag-content"]}>
        {tag.icon}
        {tag.text}
      </div>
    </Tag>
  );
};
